// The url route param is user-controllable, and it becomes the action of a form that
// auto-submits, so only https URLs on Transbank's domains may be used.
const WEBPAY_DOMAINS = ['transbank.cl', 'webpay.cl'];

function isWebpayUrl(value) {
  let url;
  try {
    url = new URL(value);
  } catch (e) {
    return false;
  }
  return url.protocol === 'https:' &&
    WEBPAY_DOMAINS.some((domain) => url.hostname === domain || url.hostname.endsWith('.' + domain));
}

export class WebpayRedirectController {

  constructor($scope, $route, $sce, $timeout, $location) {
    $scope.vm = this;
    this.sce = $sce;
    this.timeout = $timeout;
    this.scope = $scope;
    this.route = $route;
    this.location = $location;
    this.token = this.route.current.params.token;
    this.url = this.route.current.params.url;

    this.init();
  }

  init() {
    let url;
    try {
      url = atob(this.url);
    } catch (e) {
      url = null;
    }

    if (!isWebpayUrl(url)) {
      console.error('Rejected Webpay redirect URL', url);
      this.location.path('/homerd/centrodepago/fail');
      return;
    }

    this.scope.token = this.token;
    this.scope.uri = this.sce.trustAsResourceUrl(url);

    this.timeout(function() {
      angular.element("#webpayform").submit();
    });
  }
}
